<div *ngIf="showDisclaimer" class="mt-5">
    <span class="title-xs">Disclaimer: </span><span [innerHtml]="disclaimer"></span>
</div>
